export default __webpack_public_path__ + "static/media/Machine State, Cooling.3cde96b0.png";